import React from 'react';
import _ from 'underscore';
import InputMask from 'react-input-mask';

class StandardPaymentForm extends React.Component{

  constructor(){
    super(...arguments);
    this.state = {
      ccName: '',
      ccNumber: '',
      cvv: '',
      expirationMonth: (new Date()).getMonth(),
      expirationYear: (new Date()).getFullYear(),
      years: this.getYears()
    };
  }

  getYears(){
    let currentYear = (new Date()).getFullYear(),
      endYear = currentYear + 20,
      years = [];
    while (currentYear <= endYear) {
      years.push(currentYear++);
    }
    return years;
  }

  fieldChanged(k, e){
    this.setState({
      [k]: e.target.value
    }, () => {
      let {years, ...state} = this.state;
      this.props.onChange(state);
    });
  }

  render(){
    return <div className="form">
      <h4>Payment Information</h4>
      <div className="row">
        <div className="col-md-6">
          <label className="control-label">Name on Card</label>
          <input placeholder="John Doe" className="form-control" onChange={this.fieldChanged.bind(this, 'ccName')} value={this.state.ccName} />
        </div>
        <div className="col-md-6">
          <label className="control-label">Card Number</label>
          <InputMask maskChar={null} placeholder="4111 1111 1111 1111" className="form-control" mask="9999 9999 9999 9999" value={this.state.ccNumber} onChange={this.fieldChanged.bind(this, 'ccNumber')} />
        </div>
        <div className="col-sm-3">
          <label className="control-label">Expiration Month</label>
          <select className="form-control" value={this.state.expirationMonth} onChange={this.fieldChanged.bind(this, 'expirationMonth')}>
            <option value={1}>January</option>
            <option value={2}>February</option>
            <option value={3}>March</option>
            <option value={4}>April</option>
            <option value={5}>May</option>
            <option value={6}>June</option>
            <option value={7}>July</option>
            <option value={8}>August</option>
            <option value={9}>September</option>
            <option value={10}>October</option>
            <option value={11}>November</option>
            <option value={112}>December</option>
          </select>
        </div>
        <div className="col-sm-3">
          <label className="control-label">Expiration Year</label>
          <select className="form-control" value={this.state.expirationYear} onChange={this.fieldChanged.bind(this, 'expirationYear')}>
            {_.map(this.state.years, (year) => {
              return <option value={year}>{year}</option>
            })}
          </select>
        </div>
        <div className="col-sm-6">
          <label className="control-label">CVV</label>
          <input className="form-control" placeholder="XXX" onChange={this.fieldChanged.bind(this, 'cvv')} value={this.state.cvv} />
        </div>
      </div>
    </div>
  }

}

export default StandardPaymentForm;
